import { render, staticRenderFns } from "./PzCaptchaButton.vue?vue&type=template&id=68090944"
import script from "./PzCaptchaButton.vue?vue&type=script&lang=js"
export * from "./PzCaptchaButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68090944')) {
      api.createRecord('68090944', component.options)
    } else {
      api.reload('68090944', component.options)
    }
    module.hot.accept("./PzCaptchaButton.vue?vue&type=template&id=68090944", function () {
      api.rerender('68090944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Buttons/PzCaptchaButton.vue"
export default component.exports